import Highcharts from 'highcharts'

import HighchartsReact from 'highcharts-react-official'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import { useSelector } from 'react-redux'
import ChartCardContentLoader from './CardContentLoader/ChartCardContentLoader'
import NoDataImage from './NoDataImage'

HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
highchartsAccessibility(Highcharts)

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Open Sans", sansSerif',
    },
  },
})

const ChartRenderer = ({ id, options, isLoading, imgHeight = '345px' }) => {
  const { series } = options
  const { featureProps } = useSelector((state) => state.common)
  const { noDataImageURL } = featureProps

  return (
    <div>
      {isLoading ? (
        <ChartCardContentLoader />
      ) : series?.[0]?.data?.length > 0 ? (
        <HighchartsReact
          key={`highcharts-${id}`}
          highcharts={Highcharts}
          options={options}
        />
      ) : (
        <NoDataImage imageURL={noDataImageURL} height={imgHeight} />
      )}
    </div>
  )
}

export default ChartRenderer
